import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/New-York.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol For Custom Software Development in NYC?</h2>
            <p>
              At TekRevol, we are dedicated to redefining software development
              in New York City by merging innovative ideas and local insight to
              create custom-made solutions. With an established track record of
              delivering highly rated and award-winning software products, we
              are one of the forerunners in the tech industry by embracing
              state-of-the-art technology trends. Our agile approach guarantees
              swift, customized solutions, flawlessly aligning with your
              business goals. Beyond deployment, we offer constant support,
              warranting seamless software functions. Make innovation the
              driving force behind your success - collaborate with TekRevol now.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
